module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7949/img/callout-wave.svg"